var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 155,
    fontSize: 150,
    fill: "#d38bfc"
  }, "K")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 155,
    fontSize: 150,
    fill: "#d38bfc"
  }, "S")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKs);
export default __webpack_public_path__ + "static/media/ks.4cc6e7033244fdf29f6ef295c2df234f.svg";
export { ForwardRef as ReactComponent };